import {AfterViewChecked, AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Child, Group, StudentDashboard} from "../../../../types/interfaces";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {Router} from "@angular/router";
import {NavigationService} from "../../../../services/navigation/navigation.service";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {IonAccordionGroup, IonModal, ModalController} from "@ionic/angular";
import {group} from "@angular/animations";
import {PersistenceService} from "../../../../services/mygreencountry/persistence.service";
import {TranslocoService} from "@jsverse/transloco";
import {StudentRequestComponent} from "../../../../shared/components/modals/student-request/student-request.component";
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {OverlayEventDetail} from '@ionic/core/components';
import {CONTACT_WAYS} from "../../../../shared/constants";
import {AppInboxService} from "../../../../services/appInbox/app-inbox.service";
import {AppUpdatesInfo} from "../../../../types/apiResponse.interface";
import {BirthdayCardComponent} from "../../../../shared/components/modals/birthday-card/birthday-card.component";
import {AppUpdatesComponent} from "../../../../shared/components/modals/app-updates/app-updates.component";

@Component({
    selector: 'app-parent-dashboard',
    templateUrl: './parent-dashboard.component.html',
    styleUrls: ['./parent-dashboard.component.scss'],
})
export class ParentDashboardComponent implements OnInit {
    windowWidth: number;

    activeFuturesGroupsTabs:boolean = false;
    activePassedGroupsTabs:boolean = false;
    activeCurrentGroupsTabs:boolean = true;

    hasNewUpdates:boolean = false;
    showNewUpdatesModal:boolean = false;
    updatesModalInfo: AppUpdatesInfo;

    studentHasGroups: boolean | undefined = undefined;
    showStudentActions: boolean = false;
    hasNotPaidCourses: boolean = false;

    activeTabGroups: Group[] | undefined = undefined;
    currentGroups: Group[] | undefined = undefined;
    pastGroups: Group[] | undefined = undefined;
    futureGroups: Group[] | undefined = undefined;
    pastGroupsIds: number[] | undefined = undefined;
    currentGroupsIds: number[] | undefined = undefined;
    activeTabPaidGroups: Group[] | undefined = undefined;
    currentPaidGroups: Group[] | undefined = undefined;
    futurePaidGroups: Group[] | undefined = undefined;
    currentPaidGroupsIds: number[] | undefined = undefined;

    activeChild: Child = {} as Child;
    children: Child[] = [];
    hideChildCard: boolean = false
    hideChildrenDropDown: boolean = false

    student: StudentDashboard | null = null;
    notification: null | string = '';
    videoLink: string = 'https://www.youtube.com/embed/A_SUeielXHA';
    saveVideoLink: SafeResourceUrl;

    children$ = this.parentService.getChildren();
    activeGroupTime$ = this.GCService.getActiveGroupTime();
    activeChild$ = this.parentService.getActiveChild();

    @ViewChild('accordionGroup') accordionGroup: IonAccordionGroup;
    @ViewChild(IonModal) modal: IonModal;
    private processRequest: boolean = false;

    constructor(
        public myGcService: MyGreenCountry,
        private preloaderService: PreloaderService,
        public router: Router,
        private parentService: ParentService,
        private GCService: MyGreenCountry,
        private persistenceService: PersistenceService,
        private modalCtrl: ModalController,
        private authService: AuthService,
        private sanitizer: DomSanitizer,
        private appInboxService:AppInboxService
    ) {
        this.activeChild$.subscribe({
            next: (child) => {

                this.loadData(child);
            }
        })

        this.children$.subscribe((child) => {
            // this.hideChildrenDropDown = child.length === 1;
        })
    }

    refresh(event: any) {
        this.loadData(this.activeChild, event);

    }

    onResize(event: Event) {
        this.windowWidth = (event.target as Window).innerWidth;
    }

    isSmallScreen(): boolean {
        return this.windowWidth < 768;
    }

    loadDataFor(activeTab: string) {
        this.activeChild.phone
        this.getDashboard(this.activeChild.phone, activeTab);

    }

    onTabChange(activeTabTime: string) {

        this.getDashboard(this.activeChild.phone, activeTabTime);
    }


    ngOnInit() {

        this.windowWidth = window.innerWidth;

    }

    async loadData(child: Child | null = null, event: any | null = null) {
        if (child) {
            this.activeChild = child;

            this.getDashboard(child.phone, null, event);

        }

    }

    async getDashboard(phone: string, activeTab: string | null, event: any = null) {
        await this.preloaderService.showLoading('Зачекайте, будь ласка');

        this.processRequest = true;

        this.resetData();

        this.parentService.getDashboard(phone, activeTab)

            .subscribe({

                next: (response) => {

                    this.student = response.student;

                    // this.appInboxService.getUserToken(this.student.id, this.student.email, this.student.phone);

                    if (response.student.videoLink) {
                        this.videoLink = response.student.videoLink;
                    }

                    this.createSafeUrl(this.videoLink);

                    this.GCService.setActiveGroupTime(this.student.activeTimeTab)

                    this.studentHasGroups = this.student.totalGroupAmount > 0;

                    this.checkTabsPriority()

                    if (this.studentHasGroups) {

                        this.filterGroups();
                    }

                    this.notification = response.student.studentComment;
                },

                error: (error) => {

                    if (error.status === 422 || error.status === 401 || error.status === 500) {
                        this.authService.logout();
                    }


                    //@TODO: show error message
                    console.log('error', error)

                },

                complete: () => {

                    this.preloaderService.hideLoading();
                    this.processRequest = false;

                    if (event) {
                        event.target.complete();
                    }

                }

            })

    }

    resetData() {
        this.activeTabGroups = undefined;
        this.activeTabPaidGroups = undefined;
        this.showStudentActions = false;
    }


    enterAsActiveStudent(child: Child) {

        this.parentService.enterAsActiveStudent(child);
    }


    chooseActiveChild(selectedChild: Child): void {
        const nativeEl = this.accordionGroup;

        nativeEl.value = undefined;

        this.parentService.setActiveChild(selectedChild);
        this.toggleHideChildCard();
    }

    filterGroups() {

        if (this.student && this.student.groups) {

            let activeTabTime = this.activeGroupTime$.value;

            let updateGroupData = (groupTime: string, time: string, groups: any[]) => {
                let filteredGroups = groups.filter(group => group.time === groupTime);

                this.hasNotPaidCourses = filteredGroups.some(group => group.debts.debt_amount > 0 && group.hasEmptySeats);


                let paidGroups = filteredGroups.filter(group => !group.isReserve);
                let paidGroupIds = paidGroups.map(group => group.id);

                this.persistenceService.set(`${time}PaidGroupsIds`, paidGroupIds);

                this.parentService.setCurrentGroupsLinks(paidGroups.map(group => ({
                    title: group.title,
                    parentMeetingUrl: group.parentMeetingUrl,
                    parentMeetingUrlZNO: group.parentMeetingUrlZNO,
                    practicingUrl: group.practicingUrl,
                    telegramUrlFullCourse: group.telegramUrlFullCourse,
                    telegramUrl: group.telegramUrl,
                    id: group.id,
                    typeCourse: group.typeCourse,
                    time: group.time

                })));

                this.activeTabGroups = filteredGroups;
                this.activeTabPaidGroups = paidGroups;
                this.showStudentActions = paidGroups.length > 0;
            };

            switch (activeTabTime) {
                case 'isPast':
                    updateGroupData('isPast', 'past', this.student.groups);
                    break;
                case 'isFuture':
                    updateGroupData('isFuture', 'future', this.student.groups);
                    break;
                case 'isCurrent':
                    updateGroupData('isCurrent', 'current', this.student.groups);
                    break;
                default:
                    updateGroupData('isCurrent', 'current', this.student.groups);
                    break;
            }

            if (this.activeTabPaidGroups && this.activeTabPaidGroups.length > 0) {
                this.showStudentActions = true;
            }


        }
    }


    toggleHideChildCard() {
        this.hideChildCard = !this.hideChildCard;
    }

    goToPage(route: string) {
        this.router.navigate([route])
    }

    private hasGroupsOfType(groupType: string): boolean | undefined {
        if (this.processRequest) {
            return undefined;
        }
        return this.student?.groups?.some(group => group.time === groupType)
            && this.activeGroupTime$.value === groupType;
    }

    get hasFutureGroups(): boolean | undefined {
        return this.hasGroupsOfType('isFuture');
    }

    get hasPastGroups(): boolean | undefined {
        return this.hasGroupsOfType('isPast');
    }

    get hasCurrentGroups(): boolean | undefined {
        return this.hasGroupsOfType('isCurrent');
    }


    async openRequestModal(type: string) {
        let modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();
    }


    checkTabsPriority() {
        this.activeCurrentGroupsTabs = false;
        this.activePassedGroupsTabs = false;
        this.activeFuturesGroupsTabs = false;

        if (this.student?.activeTimeTab == 'isFuture') {
            this.activeFuturesGroupsTabs = true;
        } else if (this.student?.activeTimeTab == 'isPast') {
            this.activePassedGroupsTabs = true;
        } else {
            this.activeCurrentGroupsTabs = true;
        }
    }

    createSafeUrl(videoLink: string) {
        this.saveVideoLink = this.sanitizer.bypassSecurityTrustResourceUrl(videoLink);
    }

    close() {
        this.modal.dismiss(null, 'cancel');
    }

    confirm() {
        this.modal.dismiss(null, 'confirm');
    }

    reloadPage(child:Child){
        this.loadData(child);
    }

    onWillDismiss(event: Event) {
        let ev = event as CustomEvent<OverlayEventDetail<string>>;

        if (ev.detail.role === 'confirm') {
            this.authService.cleanStorage();

            this.router.navigate(['/login'], {
                queryParams: { freshman: true }
            });

        }
    }

    protected readonly CONTACT_WAYS = CONTACT_WAYS;
}
